/**
 * TABS
 * 
 * Js for the common tabs component.
 * 
 * USAGE:
 *
 * Use the following dom structure:
 *
 * <div data-bb-tabs>
 *   <ul class='bb_tabs'>
 *      <li class='bb_tab bb_tab_active' data-target-id='#target_id1'></li>
 *      <li class='bb_tab' data-target-id='#target_id2'></li>
 *      ...
 *   </ul>
 *   <div id='target_id1' class='bb_tabs_content bb_tab_active'>...<div>
 *   <div id='target_id2' class='bb_tabs_content'>...<div>
 * </div>
 *
 * These are the events triggered by the tabs and can be listened to extend the
 * behaviour of the component:
 *
 * - bb_tabs.init: when the tabs component is initialized.
 * - bb_tabs.change: when the user click on a tab and the target element is made
 *                   visible.
 *
 * @see https://dedsert.atlassian.net/wiki/display/DEV/Tabs
 * 
 */
import $ from 'jquery';
import './tabs.scss';

$.fn.bb_tabs = function(method, params) {
    return this.each(function() {
        /**
         * This is the main element containing both the tabs and the content
         * elements.
         * @type {jQuery}
         */
        var component = $(this);

        /**
         * This is the element containing the tabs.
         * @type {jQuery}
         */
        var tabs_container = $('.bb_tabs', component);

        /**
         * This is a collection of all the tabs in this component.
         * @type {jQuery}
         */
        var all_tabs = $('.bb_tab', tabs_container);

        /**
         * This is a collection containing all the target content elements.
         * @type {jQuery}
         */
        var all_tabs_content = $('.bb_tabs_content', component);

        /**
         * This option makes the tabs autoexpand to cover all the width of
         * the container element.
         * @type {boolean}
         */
        var auto_expand = component.data('autoExpand');

        function activateTab(tab) {
            tab = $(tab);
            var tab_content = $(tab.data('targetId').toString());

            all_tabs.removeClass('bb_tab_active');
            tab.addClass('bb_tab_active');
            all_tabs_content.removeClass('bb_tab_active');
            tab_content.addClass('bb_tab_active');

            component.trigger('bb_tabs.change', [tab, tab_content]);
        }

        function disableTab(tab) {
            $(tab).addClass('bb_tab_disabled');
        }

        function enableTab(tab) {
            $(tab).removeClass('bb_tab_disabled');
        }

        function init() {
            // Graphical initialization
            if (auto_expand) {
                var width = 100 / all_tabs.length;
                all_tabs.width(width + '%');
            }

            // Events initialization
            tabs_container.on('click', '.bb_tab', function() {
                activateTab(this);
            });

            component.trigger('bb_tabs.init', [component]);
        }

        function _getTabFromSelector(selector) {
            if (typeof selector === 'number') {
                return all_tabs.eq(selector);
            } else {
                return all_tabs.filter(selector);
            }
        }

        function selectItem(tabSelector) {
            var tab = _getTabFromSelector(tabSelector);
            activateTab(tab);
        }

        function disableItem(tabSelector) {
            var tab = _getTabFromSelector(tabSelector);
            disableTab(tab);
        }

        function enableItem(tabSelector) {
            var tab = _getTabFromSelector(tabSelector);
            enableTab(tab);
        }

        if (method === undefined) {
            init();
        } else {
            switch (method) {
                case 'select':
                    selectItem(params);
                    break;
                case 'disable':
                    disableItem(params);
                    break;
                case 'enable':
                    enableItem(params);
                    break;
            }
        }
    });
};

export function createBbTabs(el) {
    $(el).bb_tabs();
}

export function selectTab(el, params) {
    $(el).bb_tabs('select', params);
}

export function disableBbTabs(el, params) {
    $(el).bb_tabs('disable', params);
}

export function enableBbTabs(el, params) {
    $(el).bb_tabs('enable', params);
}
